type FileData = {
  id: string,
  programId: string,
  name: string,
  fileUrl: string | undefined,
  programName?: string,
};

type FileDataPayload = {
  programId: string,
  name: string,
  file: File | undefined,
};

type FileDataModal = FileDataPayload & {
  subjectId: string,
};

const FILES_UI = [
  {
    label: 'Nombre', key: 'name', showOnTable: true, showOnModal: true, typeField: 'text', valueType: 'string',
  },
  {
    label: 'Asignatura', key: 'subjectId', showOnTable: false, showOnModal: true, typeField: 'select', selectFields: [] as { id: string, name: string }[], valueType: 'string', valueToRetrieveFromSelect: 'id',
  },
  {
    label: 'Programa', key: 'programName', showOnTable: true, showOnModal: false, typeField: 'text', valueType: 'string',
  },
  {
    label: 'Programa', key: 'programId', showOnTable: false, showOnModal: true, typeField: 'select', selectFields: [] as { id: string, name: string }[], valueType: 'string', valueToRetrieveFromSelect: 'id',
  },
  {
    label: 'Archivo', key: 'file', showOnTable: false, showOnModal: true, typeField: 'file', valueType: 'file',
  },
  {
    label: 'Acciones', key: 'actions', showOnTable: true, showOnModal: false, typeField: 'other', valueType: 'string',
  },
];

export {
  FileData,
  FileDataPayload,
  FileDataModal,
  FILES_UI,
};
